import React, { createContext, useState, useContext } from 'react'
import axios from "axios";
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';

import book6 from '../../img/book6.jpg'
import book7 from '../../img/book7.jpg'
import book8 from '../../img/book8.jpg'
import book9 from '../../img/book9.jpg'
import book10 from '../../img/book10.jpg'
import book11 from '../../img/book11.jpg'

import { Buffer } from 'buffer';
import styled from 'styled-components';
const BodyImg = styled.img`
height:100px;
`;
// @ts-ignore
window.Buffer = Buffer;


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  bgcolor: 'background.paper',
  maxHeight: 800,
  overflowX: "auto",
  overflowY: "auto",
  // border: '2px solid #000',
  // boxShadow: 24,
  p: 6,
};
const closeButtonStyle = {
  height: 0,
  textAlign: "right",
};

function RecommendBooks(props) {


  const [cnt, setcnt] = useState();
  const [GridData, setGridData] = useState();
  const [loading, setLoading] = useState(false);//検索中
  const [Blobs, setBlobs] = useState([]);//画像データ
  const [B, setB] = useState("");//画像データ


  React.useEffect(() => {
    setLoading(true);

    // let url = `http://localhost:5000/v1/training/events/books`;
    let url = process.env.REACT_APP_API_BASE_URL + `/v1/training/events/books`;
    axios.post(url, {
    }).then((abc) => {

      console.log("-------------------")
      console.log(abc.data);
      setBlobs(abc.data)
      setLoading(false)

      var i = 0;
      abc.data.forEach(e => {

          e.index = i;
          var u = 0;
          e.forEach(file => {
              // let url2 = `http://localhost:5000/v1/training/events/book_image/` + file.url;
              let url2 = process.env.REACT_APP_API_BASE_URL + `/v1/training/events/book_image/` + file.url;
              axios.get(url2).then((r) => {
                  // abc.data[e.index][u]['url'] = r.config.url;
                  // setBlobs(abc.data)
                  // u++;
              });
          });
          i++;
      });
      setLoading(false)
    });
  }, []);


  return (
    <Modal
      open={props.open}
      onClose={() => props.setOpen(false)}
    >
      <Box sx={style}>
        <Box sx={closeButtonStyle}>
          <IconButton onClick={() => props.setOpen(false)}>
            <CloseIcon fontSize={'large'} />
          </IconButton>
        </Box>
        <Typography sx={{ textAlign: "center", fontSize: 28, fontWeight: 'bold', mb: 2 }} gutterBottom>セルフスタディ(推薦図書)</Typography>


        <div style={{ textAlign: "center", padding: 10, marginBottom: 10, border: "solid" }}>挑戦すべき高い目標を掲げ、創造的努力をすることにより人も企業も発展する。</div>
        <div style={{ textAlign: "center" }}>自分自信を変える事で、組織が変わり、そして会社も変わる。会社を発展させていくには、自分自身を発展・変革させなければならない。</div>
        <div style={{ marginTop: 10 }}>※価格は参考です</div>

        {loading == false && Blobs[0] ?
          Blobs.map(function (v, i) {
            return <Box>
              <Card
                variant="outlined"
                sx={{ display: 'flex', flexWrap: 'wrap', backgroundColor: '#4682b4', color: 'white', pl: 2, pt: 0.5, pb: 0.5, fontWeight: 'bold', letterSpacing: 2, border: 'none', borderRadius: 0 }}
              >
                {v[0].data.category_title}
              </Card>
              <Box sx={{ p: 3 }}>
                <Typography sx={{ fontsize: 16, pb: 3 }}>
                  {v[0].data.training_events_category_id == 6 ? "時代や環境が変わっても商売には不変の哲学があります。一方、その前提を理解していく上で革新性が求められます。"
                    : v[0].data.training_events_category_id == 7 ? "どんな事業であっても問題が発生しないことはありません。問題を発見する力とその問題を解決するために、誰もが問題解決能力を身に着ける必要があります。"
                      : v[0].data.training_events_category_id == 8 ? "仕事に対して誇り・やりがいを感じている、仕事に熱心に取り組めている、仕事から活力を得ている、これらが満たされている状態のこと。"
                        : v[0].data.training_events_category_id == 9 ? "ホスピタリティとは思いやり・心からのおもてなしという意味です。心からお客様に喜んでもらえることを考える力を身につけましょう。"
                          : v[0].data.training_events_category_id == 10 ? "2030年までに持続的可能でより良い世界を目指す国際目標。まずは内容を知る、学ぶことで私たち自身が積極的に行動できるようにしましょう。"
                            : v[0].data.training_events_category_id == 11 ? "今後の環境変化に対応し、世の中に溢れる情報の中から自分にとって重要なものを選択し、活用する能力を高めて行きましょう。" : ""}
                </Typography>
                <Box sx={{ display: 'flex' }}>
                  {v.map(function (b, i) {
                    console.log("====")
                    console.log(b)
                    return <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <img src={b.url} alt={b.data.title} width={120} />
                      <Typography sx={{ fontSize: 15, pl: 2, pr: 5 }} width={150}>定価　{b.data.training_full_price}<br />{b.data.is_rental == 1 ? "(本社2階本棚貸出可)" : ""}</Typography>
                    </Box>
                  }, this)}

                </Box>
              </Box>
            </Box>
          }, this) : ""}


      </Box>
    </Modal>
  );
};

export default RecommendBooks;
